export const getDeliverableQuestionVariable = (questionId: string): string => {
  const normalized = questionId.replace(/-/g, '_').toUpperCase();
  return `{{${normalized}}}`;
};
